import { ImgHTMLAttributes } from "react";
import { supabaseImageUrl, supabaseSrcSet } from "@/lib/image";

interface LazyImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  /**
   * Rendered CSS width in pixels. Drives Supabase image transforms + srcSet.
   * Defaults to min(width prop, 1200) so intrinsic DB widths (often 4000px+)
   * don't force the browser to download an oversized asset.
   */
  displayWidth?: number;
}

export default function LazyImage(props: LazyImageProps) {
  const { src, width, srcSet, displayWidth, ...rest } = props;
  const numericWidth = typeof width === "number" ? width : Number(width) || undefined;
  const renderWidth = displayWidth ?? (numericWidth ? Math.min(numericWidth, 1200) : undefined);
  const finalSrc = typeof src === "string" && renderWidth
    ? supabaseImageUrl(src, { width: renderWidth })
    : src;
  const finalSrcSet = typeof src === "string" && renderWidth && !srcSet
    ? supabaseSrcSet(src, renderWidth)
    : srcSet;
  return (
    <img
      loading="lazy"
      decoding="async"
      src={finalSrc as string | undefined}
      srcSet={finalSrcSet}
      width={width}
      {...rest}
    />
  );
}